import styled from 'styled-components'
import { rem } from 'polished'
import Sheet from 'components/utils/Sheet'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import {
  CANVAS_CONTENT_WIDTH,
  CANVAS_HORIZONTAL_PADDING,
  CANVAS_NARROW_BREAKPOINT,
  CANVAS_NARROW_CONTENT_WIDTH,
  CANVAS_NARROW_HORIZONTAL_PADDING,
} from './constants'

export const CanvasContainer = styled.div`
  container-name: chat-itinerary-canvas;
  container-type: inline-size;
  height: 100%;
`

export const ScrollableContainer = styled.div`
  --itinerary-canvas-width: ${rem(CANVAS_CONTENT_WIDTH)};
  --itinerary-canvas-padding: ${rem(CANVAS_HORIZONTAL_PADDING)};
  --itinerary-stop-image-size: ${rem(104)};
  --itinerary-item-image-width: ${rem(179)};
  --itinerary-item-card-padding: ${rem(16)};
  --itinerary-preview-tile-size: ${rem(40)};
  --itinerary-stop-sheet-padding: ${rem(20)};

  box-sizing: border-box;
  height: 100%;
  padding: var(--itinerary-canvas-padding);
  overflow-y: auto;
  width: 100%;
  background: ${props => props.theme.palette.neutral.default.seven};

  @container chat-itinerary-canvas (max-width: ${rem(CANVAS_NARROW_BREAKPOINT)}) {
    --itinerary-canvas-width: ${rem(CANVAS_NARROW_CONTENT_WIDTH)};
    --itinerary-canvas-padding: ${rem(CANVAS_NARROW_HORIZONTAL_PADDING)};
    --itinerary-stop-image-size: ${rem(88)};
    --itinerary-item-image-width: ${rem(132)};
    --itinerary-item-card-padding: ${rem(12)};
    --itinerary-preview-tile-size: ${rem(32)};
    --itinerary-stop-sheet-padding: ${rem(16)};
  }
`

export const SkeletonStopSheet = styled(Sheet)`
  max-width: var(--itinerary-canvas-width);
  width: 100%;
  border-radius: ${props => props.theme.borderRadius.L};
`

export const FullWidthLoadingBox = styled(LoadingBox)`
  width: 100%;
`

export const DottedConnector = styled.div`
  max-width: var(--itinerary-canvas-width);
  width: 100%;
  height: ${rem(24)};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: ${rem(15)};
    top: 0;
    bottom: 0;
    border-left: 1px dashed ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  }
`

export const ItemSpacer = styled.div`
  height: ${rem(40)};
`

export const StopContentWrapper = styled.div`
  max-width: var(--itinerary-canvas-width);
  width: 100%;
`
